// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PDFViewer-container__rsAKF{display:flex;flex-direction:column;width:var(--size-full);height:var(--size-full)}.PDFViewer-iframe__vfl8E{flex:1;width:var(--size-full);height:var(--size-full);border:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "PDFViewer-container__rsAKF",
	"iframe": "PDFViewer-iframe__vfl8E"
};
export default ___CSS_LOADER_EXPORT___;
